import { LocaleMessages } from 'vue-i18n'

const authPtBrLocaleMessages: LocaleMessages = {
  login: {
    title: 'Login',
    alert: {
      loggedIn: 'Você precisa estar logado para continuar.'
    },
    notification: {
      entered: 'Login efetuado com sucesso.',
      exited: 'Logout efetuado com sucesso.'
    },
    button: {
      goto: 'Ir para o Login'
    }
  },
  userRecovery: {
    title: 'Esqueceu sua senha?',
    alert: {
      sendEmail: 'Informe seu e-mail e nós lhe enviaremos um link para criar uma nova senha.'
    },
    notification: {
      sentEmail: 'E-mail enviado com sucesso.'
    }
  },
  userRecoveryToken: {
    description: {
      confirmNewEmail: 'Confirme seu novo e-mail',
      createPassword: 'Crie sua senha'
    },
    alert: {
      expiredConfirmNewEmail: 'O link para confirmar seu novo e-mail expirou.',
      expiredCreatePassword: 'O link para criar sua senha expirou. Deseja enviar um novo link para o seu e-mail?'
    },
    notification: {
      confirmedNewEmail: 'Novo e-mail confirmado com sucesso.',
      createdPassword: 'Senha criada com sucesso.'
    }
  },
  user: {
    title: 'Usuário',
    pluralTitle: 'Usuários',
    field: {
      name: 'Nome',
      email: 'E-mail',
      references: 'Referências',
      password: 'Senha',
      newEmail: 'Novo e-mail',
      newPassword: 'Nova senha'
    }
  },
  group: {
    title: 'Grupo',
    pluralTitle: 'Grupos',
    field: {
      name: 'Nome',
      serial: 'N. de Série',
      references: 'Referências'
    }
  },
  module: {
    title: 'Módulo',
    pluralTitle: 'Módulos'
  },
  access: {
    title: 'Acesso',
    pluralTitle: 'Acessos',
    field: {
      user: 'Usuário',
      group: 'Grupo',
      module: 'Módulo',
      level: 'Nível',
      startDate: 'Data Inicial',
      endDate: 'Data Final',
      enabledLegacyAutologin: 'Login automático'
    },
    value: {
      level: {
        ADMINISTRATOR: 'Administrador',
        MANAGER: 'Gerente',
        OPERATOR: 'Operador',
        GUEST: 'Convidado'
      }
    }
  }
}

export default authPtBrLocaleMessages